import { Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'bey-auth-header-branding',
  templateUrl: './bey-auth-header-branding.component.html',
  styleUrls: ['./bey-auth-header-branding.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class BeyAuthHeaderBrandingComponent implements OnInit {
  constructor() {}

  /***
   *  Page title if component is used as wrapper (Content Projection)
   */
  @Input()
  title: string;

  /****
   * Custom layout prop to hide the header on all breakpoints
   */
  @Input()
  customLayout: boolean;

  ngOnInit(): void {}
}
